module.exports = ".modal-text {\n  font-size: 16px; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/common/delete-item-modal/delete-item-modal.scss
// module id = ./web/modern/components/settings/common/delete-item-modal/delete-item-modal.scss
// module chunks = 0